import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import api from '../services/api';
import { Button, Card, Input } from '../components/ui';

export default function Cart() {
  const { items, updateQty, remove, total, clear } = useCart();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userStr = localStorage.getItem('user');
  const user: any | null = (() => {
    try { return userStr ? JSON.parse(userStr) : null; } catch { return null; }
  })();
  const [customer, setCustomer] = useState({ username: '', email: '', password: '' });
  const [ip, setIp] = useState('');
  const [port, setPort] = useState('');

  const handleCheckout = async () => {
    if (items.length === 0) return;
    setLoading(true);
    try {
      const payload: any = {
        items: items.map(i => ({ product_id: i.product_id, quantity: i.quantity })),
        payment_method: 'paypal',
      };
      if (!user) {
        payload.customer = { username: customer.username, email: customer.email, password: customer.password };
      }
      if (ip) payload.ip = ip;
      if (port) payload.port = Number(port);
      const res = await api.post('/orders/create', payload);
      const { orderId, approveLink } = res.data;
      if (orderId) localStorage.setItem('pendingOrderId', orderId);
      if (approveLink) window.location.href = approveLink;
      else navigate('/payment/cancel');
    } catch {
      alert('Error al iniciar compra');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-display text-3xl font-bold text-gray-100 mb-8">Carrito</h1>

      {!user && (
        <Card className="mb-8">
          <h2 className="font-semibold text-gray-100 mb-4">Datos de facturación / cuenta</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              placeholder="Usuario"
              value={customer.username}
              onChange={e => setCustomer(c => ({ ...c, username: e.target.value }))}
            />
            <Input
              placeholder="Email"
              type="email"
              value={customer.email}
              onChange={e => setCustomer(c => ({ ...c, email: e.target.value }))}
            />
            <Input
              placeholder="Contraseña"
              type="password"
              value={customer.password}
              onChange={e => setCustomer(c => ({ ...c, password: e.target.value }))}
            />
          </div>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <Input placeholder="IP del servidor" value={ip} onChange={e => setIp(e.target.value)} />
            <Input placeholder="Puerto" value={port} onChange={e => setPort(e.target.value)} />
          </div>
        </Card>
      )}

      {items.length === 0 ? (
        <Card className="text-center py-16">
          <svg className="w-16 h-16 mx-auto text-gray-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13h10l-2 8H7L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p className="text-gray-400 mb-6">No hay productos en el carrito</p>
          <Button variant="outline" onClick={() => navigate('/')}>
            Ir al catálogo
          </Button>
        </Card>
      ) : (
        <div className="space-y-4">
          {items.map(it => (
            <Card key={String(it.product_id)} padding="md" className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div>
                <div className="font-semibold text-gray-100">{it.name}</div>
                <div className="text-sm text-gray-500">${Number(it.price).toFixed(2)} c/u</div>
              </div>
              <div className="flex items-center gap-4 w-full sm:w-auto">
                <input
                  type="number"
                  min={1}
                  value={it.quantity}
                  onChange={e => updateQty(it.product_id, Math.max(1, Number(e.target.value)))}
                  className="w-20 bg-rs-surface border border-rs-border rounded px-2 py-1.5 text-gray-100 text-center"
                />
                <span className="w-24 text-right font-semibold text-rs-accent">
                  ${(Number(it.price) * Number(it.quantity)).toFixed(2)}
                </span>
                <button
                  onClick={() => remove(it.product_id)}
                  className="text-red-400 hover:text-red-300 transition-colors"
                  title="Eliminar"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </Card>
          ))}

          <Card className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xl font-display font-bold text-rs-accent">
              Total: ${Number(total()).toFixed(2)}
            </div>
            <div className="flex gap-3">
              <Button variant="ghost" onClick={clear} disabled={loading}>
                Vaciar
              </Button>
              <Button onClick={handleCheckout} loading={loading} size="lg">
                Pagar con PayPal
              </Button>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
